export default "__VITE_ASSET__CFCuNXXa__"